// Dati storici rimossi dal codice — salvati su Supabase (ore_lavorate)
export function generateDemoData() {
  return [];
}

export function formatDate(dateStr, options = {}) {
  const defaults = { weekday: "short", day: "numeric", month: "short" };
  return new Date(dateStr).toLocaleDateString("it-IT", { ...defaults, ...options });
}

export function todayStr() {
  return new Date().toISOString().split("T")[0];
}

export function filterByPeriod(oreData, periodo) {
  const oggi = new Date();
  const todayDate = todayStr();
  return oreData.filter((o) => {
    if (!o.ore && !o.stato) return false; // skip vuoti
    const d = new Date(o.data);
    if (periodo === "oggi") return o.data === todayDate;
    if (periodo === "settimana") { const w = new Date(oggi); w.setDate(w.getDate() - 7); return d >= w; }
    if (periodo === "mese") { const m = new Date(oggi); m.setDate(m.getDate() - 30); return d >= m; }
    return true;
  });
}

export function getInitials(name) {
  return name.split(" ").map((n) => n[0]).join("");
}

export function prepareExportData(oreData) {
  return oreData.map((o) => ({
    Data: o.data,
    Dipendente: o.dipendente,
    Cantiere: o.cantiere,
    Ore: o.ore || o.stato || "",
    Note: o.note || "",
  }));
}
